import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { pcmpLookupQueryKeys, updatePcmpDepartmentDivision } from '../api/pcmpLookups.api';
import { pcmpReportQueryKeys } from '../api/pcmpReports.api';
import { pcmpDivisionLabel } from '../constants/pcmpQueue.constants';
import type { PcmpDivision } from '../types/pcmpQueue.types';

/** Set one department's PCMP division. Errors stay inline in the dialog. */
export function useSavePcmpDepartmentDivision(departmentId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (division: PcmpDivision | null) =>
      updatePcmpDepartmentDivision(departmentId, division),
    onSuccess: (department) => {
      // The pickers and the report filters group departments by this division.
      void queryClient.invalidateQueries({ queryKey: pcmpLookupQueryKeys.departments() });
      // The reports group their rows by division too.
      void queryClient.invalidateQueries({ queryKey: pcmpReportQueryKeys.all() });
      toast.success(
        `${department.name}: PCMP division set to ${pcmpDivisionLabel(department.divisionCode)}`,
      );
      onSuccess();
    },
  });
}
